module.exports = __webpack_public_path__ + "static/media/speedometer-grey.3bf25525.svg";